import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { isEmpty, set, size, toInteger } from "lodash";
import toast from "react-hot-toast";

import { Link, withRouter } from "react-router-dom";

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Label,
  Alert,
  Row,
} from "reactstrap";
import Select from "react-select";
import { Formik, Field, ErrorMessage, Form, validateYupSchema } from "formik";
import * as Yup from "yup";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { createStaffRequest } from "store/Staff/actions";
import InputMask from "react-input-mask";

class CreateStaff extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const Staff = this.state;
    console.log("error", this.props.error);
    return (
      <React.Fragment>
        <div className="page-content mb-2">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title="Staffs" breadcrumbItem="Register Staff" />
            <div className="p-2">
              {this.props.error && (
                <Alert color="danger">
                  {this.props.error.response.data.detail}
                </Alert>
              )}
            </div>
            <Formik
              enableReinitialize={true}
              initialValues={{
                name: (Staff && Staff.name) || "",
                email: (Staff && Staff.email) || "",
                contact_number: (Staff && Staff.contact_number) || "",
                CNIC: (Staff && Staff.CNIC) || "",
                // is_homesampler:
                //         (homesampler && homesampler.is_homesampler) || true,
                password: (Staff && Staff.password) || "",
                // Lab_Id:
                //         (Staff && Staff.Lab_Id) ||  JSON.parse(localStorage.getItem("authUser")).email, //RECHECK THIS LATER
              }}
              validationSchema={Yup.object().shape({
                name: Yup.string().required("Name is required"),
                email: Yup.string()
                  .email("Email is invalid")
                  .required("Email is required"),
                contact_number: Yup.string()
                  .required("Contact Number is required")
                  .matches(
                    /^(\+92|0092|92|0)?3[0-9]{2}-[0-9]{7}$/g, //g for global means it will check for all the string
                    "Please write a valid contact number e.g. 0300-1234567"
                  ),
                password: Yup.string().required("password is required"),

                CNIC: Yup.string()
                  .required("CNIC is required")
                  .matches(/^([0-9]{5}-[0-9]{7}-[0-9]{1})$/g, "Invalid CNIC"),
                // check for type error
              })}
              onSubmit={values => {
                const CreatedUser = {
                  name: values.name,
                  email: values.email,
                  contact_number: values.contact_number,
                  password: values.password, //needs to be changed
                  CNIC: values.CNIC,
                  // is_homesampler: true,
                  // Lab_Id: values.Lab_Id, //RECHECK THIS LATER
                };
                this.props.registerStaff(CreatedUser);
              }}
            >
              {({
                errors,
                status,
                touched,
                values,
                setFieldValue,
                setFieldError,
              }) => (
                <Form>
                  <Row>
                    <Col xs="12">
                      <Card>
                        <CardBody>
                          <div
                            className="d-flex"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div>
                              <CardTitle className="h4">
                                Staff Information
                              </CardTitle>
                              <p className="card-title-desc">
                                Fill all the Staff information below
                              </p>
                            </div>
                          </div>

                          <Row>
                            <Col sm="6">
                              <div className="mb-3">
                                <Label className="form-label">Name</Label>
                                <Field
                                  name="name"
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                              <div className="mb-3">
                                <Label className="form-label">Email</Label>
                                <Field
                                  name="email"
                                  type="email"
                                  className={
                                    "form-control" +
                                    (errors.email && touched.email
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                              <div className="mb-3">
                                <Label className="form-label">Password</Label>
                                <Field
                                  name="password"
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.password && touched.password
                                      ? " is-invalid"
                                      : "")
                                  }
                                ></Field>
                                <ErrorMessage
                                  name="password"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </Col>

                            <Col sm="6">
                              <div className="mb-3">
                                <Label className="form-label">
                                  Contact Number
                                </Label>
                                {
                                  // InputMask is not being validated by Formik so we have to use this hack to validate it
                                  // the hack is to use the value from Formik and pass it to InputMask and then use the onChange event to update the value in Formik
                                }
                                <Field
                                  // for validation
                                  // TODO: fix validation
                                  name="contact_number"
                                  onChange={e => {
                                    console.log("e", e.target.value.length);
                                    if (
                                      e.nativeEvent.inputType ===
                                      "deleteContentBackward"
                                    ) {
                                      setFieldValue(
                                        "contact_number",
                                        e.target.value
                                      );
                                      return;
                                    }
                                    // get first 4 digits
                                    if (e.target.value.length === 5) {
                                      setFieldValue(
                                        "contact_number",
                                        e.target.value.slice(0, 4) +
                                          "-" +
                                          e.target.value.slice(4)
                                        // e.target.value(4) // get last 7 digits
                                      );
                                    } else if (e.target.value.length === 13) {
                                      return;
                                    } else {
                                      setFieldValue(
                                        "contact_number",
                                        e.target.value
                                      );
                                    }
                                  }}
                                  type="text"
                                  placeholder="0322-1234567"
                                  className={
                                    "form-control" +
                                    (errors.contact_number &&
                                    touched.contact_number
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="contact_number"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>

                              <div className="mb-3">
                                <Label className="form-label">CNIC</Label>
                                <Field
                                  name="CNIC"
                                  type="text"
                                  placeholder="00000-0000000-0"
                                  onChange={e => {
                                    console.log("e", e.target.value.length);
                                    if (
                                      e.nativeEvent.inputType ===
                                      "deleteContentBackward"
                                    ) {
                                      setFieldValue(
                                        "CNIC",
                                        e.target.value
                                      );
                                      return;
                                    }
                                    // get first 5 digits
                                    if (e.target.value.length === 6) {
                                      setFieldValue(
                                        "CNIC",
                                        e.target.value.slice(0, 5) +
                                          "-" +
                                          e.target.value.slice(5)
                                        // e.target.value(4) // get last 7 digits
                                      );
                                    } else if (e.target.value.length === 14) {
                                      setFieldValue(
                                        "CNIC",
                                        e.target.value.slice(0, 13) +
                                          "-" +
                                          e.target.value.slice(13)
                                      );
                                    } else if (e.target.value.length === 16) {
                                      return;
                                    } else {
                                      setFieldValue(
                                        "CNIC",
                                        e.target.value
                                      );
                                    }
                                  }}
                                  className={
                                    "form-control" +
                                    (errors.CNIC && touched.CNIC
                                      ? " is-invalid"
                                      : "")
                                  }
                                ></Field>
                                <ErrorMessage
                                  name="CNIC"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </Col>
                          </Row>
                          <div className="d-flex flex-wrap gap-2">
                            <Button type="submit" color="primary">
                              Register
                            </Button>
                            <Button
                              onClick={() => {
                                toast.error("Staff Creation Cancelled");
                                this.props.history.push("/stafflist");
                              }}
                              color="secondary"
                            >
                              Cancel
                            </Button>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

CreateStaff.propTypes = {
  history: PropTypes.object,
  className: PropTypes.any,
  onGetTests: PropTypes.func,
  //   homesampler: PropTypes.object,
  //   homesamplers: PropTypes.array,
  Staff: PropTypes.object,
  Staffs: PropTypes.array,
  registerStaff: PropTypes.func,
  error: PropTypes.any,
};

const mapStateToProps = state => {
  return {
    Staff: state.StaffReducer.Staff,
    error: state.StaffReducer.error,
  };
};

const mapDispatchToProps = dispatch => ({
  registerStaff: homesampler => dispatch(createStaffRequest(homesampler)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateStaff));
